class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.item = $(this).closest(".productView");
    this.isFullWidth = this.item.is(".layout-4");
    this.isInitialized = false;

    this.onVariantInit();
    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantInit() {
    this.status = Object.create({});
    this.status.variantName = "Taille";
    this.status.customSize = "PERSONNALISÉE";
    this.status.plusSizes = [
      "EU50",
      "EU52",
      "EU54",
      "EU56",
      "EU58",
      "EU60",
      "PERSONNALISÉE",
    ];

    this.checkOptionsValidate(); // Check custom size option value is validate or not.
    this.buyBefor(); // Add to cart event handler

    this.updateOptions(); // Get variant select option value
    this.updateSizeChart();
    this.updateMasterId();
    this.preOptions = this.currentVariant?.options;
    this.renderProductAjaxInfo();
    this.renderProductInfo();
    if (!this.currentVariant) {
      this.updateAttribute(true);
    } else {
      this.updateAttribute(false, !this.currentVariant.available);
    }
    this.updateVariantStatuses();
    this.isInitialized = true;
  }

  onVariantChange(event) {
    if (!event.target.closest("fieldset")) return;
    this.preOptions = this.currentVariant?.options;
    this.updateOptions();
    let curIndex = this.options.findIndex((option) =>
      this.status.plusSizes.includes(option)
    );
    let index = this.currentVariant?.options
      ? this.currentVariant.options.findIndex((option) =>
          this.status.plusSizes.includes(option)
        )
      : "undefined";
    if (
      event.target.name !== this.status.variantName ||
      (index !== "undefined" &&
        !(
          !this.currentVariant.options ||
          (index > -1 && curIndex > -1) ||
          (index === -1 && curIndex === -1)
        ))
    ) {
      let variantImg = this.currentVariant?.featured_image;
      let variantMedia = document.querySelector("[data-variant-media]");
      if (variantMedia && variantImg) {
        variantMedia.firstElementChild.classList.add("loading");
        variantMedia
          .querySelector("[data-loading-spinner]")
          .classList.remove("hidden");
      }
    }
    this.updteMobileVariant();
    this.updateSizeChart();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (
      !this.options.includes(this.status.customSize) &&
      this.querySelector('input[value="PERSONNALISÉE"]')
    ) {
      this.emptyCustomOpts();
    }
    if (!this.options.includes(this.status.customSize)) {
      const sizeChart = document.querySelector("size-chart");
      if (sizeChart) sizeChart.updateSelected();
    }

    if (!this.currentVariant) {
      if (event.target.name === "Couleur") {
        this.updateStickyButtonMedia(event);
        this.updateMediaGallery(event);
      }
      this.updateAttribute(true);
      this.updateStickyAddToCart(true);
    } else {
      this.updateVariantInput();
      this.updateMedia(event);
      this.updateURL();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateAttribute(false, !this.currentVariant.available);
      this.updateStickyAddToCart(false, !this.currentVariant.available);
      this.checkQuantityWhenVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  decodeOptions() {
    this.options = this.options.map((option) => {
      const parsedOption = this.decodeOption(option);
      return parsedOption;
    });
  }

  decodeOption(option) {
    if (option) {
      return option
        .split("Special_Double_Quote")
        .join('"')
        .split("Special_Slash")
        .join("/");
    } else {
      return null;
    }
  }

  encodeOption(option) {
    if (option) {
      return option
        .split('"')
        .join("Special_Double_Quote")
        .split("/")
        .join("Special_Slash");
    } else {
      return null;
    }
  }

  updateMasterId() {
    this.decodeOptions();
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  buyBefor() {
    const addToCartBtns = document.querySelectorAll(
      "[data-btn-addtocart], [data-dynamic-checkout-wrapper]"
    );
    const popup = document.querySelector("[data-custom-option-popup]");
    const customOption = document.querySelector("custom-option");
    addToCartBtns.forEach((button) => {
      button.addEventListener(
        "mousedown",
        this.checkOptionsValidate.bind(this)
      );
    });
    addToCartBtns.forEach((button) => {
      button.addEventListener(
        "touchstart",
        this.checkOptionsValidate.bind(this)
      );
    });

    if (
      customOption &&
      popup &&
      window.matchMedia("(max-width: 767px)").matches
    ) {
      const closeBtn = popup.querySelector("[data-close-custom-option-popup]");
      const submitBtn = popup.querySelector('[data-custom-option-submit]');
      const content = popup.querySelector("[data-custom-option-content]");
      const newOption = customOption.cloneNode(true);
      newOption.style.display = "block";
      content.appendChild(newOption);
      customOption.remove();
      const input = this.querySelector(
        `input[value="${this.status.customSize}"]`
      );
      if (input) {
        const label = this.querySelector(`label[for="${input.id}"]`);
        label && label.addEventListener("click", () => {
          if (!newOption.checkValidate() || !newOption.agreePolicy) {
            document.body.classList.add("custom-option-show");
            popup.classList.add("is-show");
          } else {
            newOption.showSelectedValues();
          }
        });
      }
      closeBtn && closeBtn.addEventListener("click", () => {
        document.body.classList.remove("custom-option-show");
        popup.classList.remove("is-show");
      });
      submitBtn && submitBtn.addEventListener("click", () => {
        let result = newOption.checkValidate();
        if (result) {
          document.body.classList.remove("custom-option-show");
          popup.classList.remove("is-show");
          newOption.showSelectedValues();
        }
      });
    }
  }

  checkOptionsValidate(event) {
    event && event.preventDefault;
    event && event.stopPropagation();
    const customOption = document.querySelector("custom-option");
    if (!customOption || !this.options?.includes(this.status.customSize))
      return;
    const addToCartBtns = document.querySelectorAll(
      "[data-btn-addtocart], [data-dynamic-checkout-wrapper]"
    );
    const result = customOption.checkValidate();
    if (!result || !this.currentVariant.available) {
      if (!result && window.matchMedia("(max-width: 767px)").matches) {
        showWarning('Les valeurs saisies dans la taille personnalisée ne sont pas valides.', 2000);
      }
      addToCartBtns.forEach((btn) => btn.setAttribute("disabled", true));
    } else {
      customOption.init();
      this.addOptionToForm();
      addToCartBtns.forEach((btn) => btn.removeAttribute("disabled"));
    }
  }

  updteMobileVariant() {
    const mobileVariant = document.querySelector(
      "[data-mobile-variant-picker]"
    );
    const selectedColor = this.querySelector('input[name="Couleur"]:checked');
    if (!mobileVariant || !selectedColor) return;
    const swatches = mobileVariant.querySelectorAll(
      ".product-form__label .pattern"
    );
    const inputs = Array.from(this.querySelectorAll('input[name="Couleur"]'));
    let index = inputs.findIndex((input) => input.value == selectedColor.value);
    if (inputs.length > 8) {
      swatches.forEach((swatch) => {
        swatch.style.cssText =
          inputs[index].nextElementSibling.firstElementChild.getAttribute(
            "style"
          );
        if (index == inputs.length - 1) {
          index = 0;
        } else {
          index += 1;
        }
      });
    } else {
      swatches.forEach((swatch) =>
        swatch.parentElement.classList.remove("selected")
      );
      mobileVariant
        .querySelector(
          `[class="${selectedColor.nextElementSibling.firstElementChild.className}"]`
        )
        .parentElement.classList.add("selected");
    }
  }

  updateSizeChart() {
    const customOption = document.querySelector("custom-option");
    const sizeChart = document.querySelector("size-chart");
    if (!customOption || !sizeChart) return;
    if (
      this.options.includes(this.status.customSize) &&
      window.matchMedia("(min-width: 768px)").matches
    ) {
      customOption.style.display = "block";
    }
    if (
      !this.options.includes(this.status.customSize) &&
      window.matchMedia("(min-width: 768px)").matches
    ) {
      customOption.style.display = "none";
    }
    if (this.options.includes(this.status.customSize)) {
      sizeChart.style.display = "none";
    } else {
      sizeChart.style.display = "block";
    }
    const customOptionBox = document.querySelector('[data-custom-size-values]');
    if (customOptionBox && !this.options.includes(this.status.customSize)) customOptionBox.style.display = 'none';
  }

  emptyCustomOpts() {
    const customOption = document.querySelector("custom-option");
    if (!customOption) return;
    const addToCart = document.querySelectorAll(
      "[data-btn-addtocart], [data-dynamic-checkout-wrapper]"
    );

    if ("function" === typeof customOption.showErrorMessage)
      customOption.showErrorMessage("");
    this.removeOptionFromFrom();
    if (this.currentVariant.available) {
      addToCart.forEach((obj) => obj.removeAttribute("disabled"));
    }
  }

  addOptionToForm() {
    const customOption = document.querySelector("custom-option");
    const forms = Array.from(
      document.querySelectorAll('form[action="/cart/add"]')
    );
    if (!this.options.includes(this.status.customSize) || !customOption) return;
    const insertElem = (name, value, form) => {
      const elem = form.querySelector(`[name="properties[${name}]"]`);
      if (elem) {
        elem.value = value;
      } else {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${name}]`;
        input.value = value;
        form.append(input);
      }
    };
    for (let form of forms) {
      insertElem("Unit", customOption.unit, form);
      Object.entries(customOption.optionValues).map(([key, value]) =>
        insertElem(key, value, form)
      );
    }
  }

  removeOptionFromFrom() {
    const customOption = document.querySelector("custom-option");
    const forms = Array.from(
      document.querySelectorAll('form[action="/cart/add"]')
    );
    if (this.options.includes(this.status.customSize) || !customOption) return;
    const removeElem = (name, form) => {
      const input = form.querySelector(`[name="properties[${name}]"]`);
      if (input) input.remove();
    };
    for (let form of forms) {
      removeElem("Unit", form);
      Object.keys(customOption.optionValues).map((key) =>
        removeElem(key, form)
      );
    }
  }

  updateMedia(event) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    if (event.target.name === this.status.variantName) {
      let curIndex = this.options.findIndex((option) =>
        this.status.plusSizes.includes(option)
      );
      let index = this.preOptions
        ? this.preOptions.findIndex((option) =>
            this.status.plusSizes.includes(option)
          )
        : "undefined";
      if (
        index !== "undefined" &&
        !((index > -1 && curIndex > -1) || (index === -1 && curIndex === -1))
      ) {
        this.updateStickyButtonMedia(event);
        this.updateMediaGallery(event);
      }
    } else {
      this.updateStickyButtonMedia(event);
      this.updateMediaGallery(event);
    }
  }

  updateStickyButtonMedia(event) {
    if (!this.currentVariant && !this.getAvailableVariant()) return;
    let currentVar = this.currentVariant
      ? this.currentVariant
      : this.getAvailableVariant();
    let variantMedia = document.querySelector(".sticky-info-container");
    if (variantMedia) {
      let image = currentVar?.featured_image;
      if (image) {
        let variantImage = variantMedia.querySelector("img");
        variantImage.setAttribute("src", image.src + "&width=180");
        variantImage.setAttribute("alt", image.alt);
      }
    }
  }

  updateMediaGallery(event) {
    let id =
      !this.currentVariant && event.target.name === "Couleur"
        ? this.getAvailableVariant().id
        : this.currentVariant.id;
    fetch(`${this.dataset.url}?variant=${id}&view=ajax_product_media`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const source = html.querySelector("[data-ajax-content]");
        const destination = document.querySelector("[data-image-gallery]");
        if (source && destination) {
          destination.replaceWith(source.querySelector("[data-image-gallery]"));
          window.galleryReinit($(".halo-productView"));
        }
      });
  }

  getAvailableVariant() {
    // only use to get the sale product available variant id
    let id;
    id = this.variantData.find(
      (variant) => variant.options[0] == this.options[0] && variant.available
    );
    return id;
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductAjaxInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `product-price-${this.dataset.product}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        const property = `product-property-${this.dataset.product}`;
        const destinationProperty = document.getElementById(property);
        const sourceProperty = html.getElementById(property);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const virantPrice = document.querySelector("[data-product-price]");
        const htmlPrice = html.querySelector("[data-product-price]");
        if (virantPrice && htmlPrice)
          virantPrice.innerHTML = htmlPrice.innerHTML;

        if (this.checkNeedToConvertCurrency()) {
          let currencyCode = document
            .getElementById("currencies")
            ?.querySelector(".active")
            ?.getAttribute("data-currency");

          Currency.convertAll(
            window.shop_currency,
            currencyCode,
            "span.money",
            "money_format"
          );
        }

        if (destinationProperty) {
          if (sourceProperty) {
            destinationProperty.innerHTML = sourceProperty.innerHTML;
            destinationProperty.style.display = "table";
          } else {
            destinationProperty.style.display = "none";
          }
        } else if (sourceProperty) {
          document
            .querySelector(".productView-product")
            .insertBefore(
              sourceProperty,
              document.querySelector(".productView-options")
            );
        }

        document
          .getElementById(`product-price-${this.dataset.product}`)
          ?.classList.remove("visibility-hidden");

        if (!this.isInitialized) return;
        const description = `[data-product-description-${this.dataset.product}]`;
        const destinationDesc = document.querySelector(description);
        const sourceDesc = html.querySelector(description);
        if (sourceDesc && destinationDesc) {
          destinationDesc.innerHTML = sourceDesc.innerHTML;
          if (destinationDesc.closest(".toggle-content--height")) {
            destinationDesc.style.maxHeight = null;
          }
        }
      });
  }

  renderProductInfo() {
    if (this.item.find("[data-sku]").length > 0) {
      this.item
        .find("[data-sku] .productView-info-value")
        .text(this.currentVariant.sku);
    }

    var inventory = this.currentVariant?.inventory_management;

    if (inventory != null) {
      var arrayInVarName = `product_inven_array_${this.dataset.product}`,
        inven_array = window[arrayInVarName];

      if (inven_array != undefined) {
        var inven_num = inven_array[this.currentVariant.id],
          inventoryQuantity = parseInt(inven_num);

        this.item
          .find('input[name="quantity"]')
          .attr("data-inventory-quantity", inventoryQuantity);

        if (this.item.find("[data-inventory]").length > 0) {
          if (inventoryQuantity > 0) {
            const showStock = this.item
              .find("[data-inventory]")
              .data("stock-level");
            if (showStock == "show") {
              this.item
                .find("[data-inventory] .productView-info-value")
                .text(inventoryQuantity + " " + window.inventory_text.inStock);
            } else {
              this.item
                .find("[data-inventory] .productView-info-value")
                .text(window.inventory_text.inStock);
            }
          } else {
            this.item
              .find("[data-inventory] .productView-info-value")
              .text(window.inventory_text.outOfStock);
          }
        }

        hotStock(inventoryQuantity);
      }
    }

    if (this.item.find(".productView-stickyCart").length > 0) {
      const sticky = this.item.find(".productView-stickyCart");
      const optionSticky = sticky.find(".select__select");

      optionSticky.val(this.currentVariant.id);
    }
  }

  updateAttribute(unavailable = true, disable = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.product}`)
      ?.querySelector('[name="add"]');
    var quantityInput = this.item.find('input[name="quantity"]'),
      notifyMe = this.item.find(".productView-notifyMe"),
      hotStock = this.item.find(".productView-hotStock"),
      buttonAddtocart = this.item.find(".product-form__submit"),
      maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));

    if (isNaN(maxValue)) {
      maxValue = maxValue = parseInt(
        buttonAddtocart.attr("data-inventory-quantity")
      );
    } else {
      maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));
    }

    if (unavailable) {
      var text = window.variantStrings.unavailable;

      quantityInput.attr("disabled", true);
      notifyMe.slideUp("slow");
      addButton.setAttribute("disabled", true);
      addButton.textContent = text;
      quantityInput.closest("quantity-input").addClass("disabled");

      if (hotStock.length > 0) hotStock.addClass("is-hiden");
    } else {
      if (disable) {
        var text = window.variantStrings.soldOut,
          subTotal = 0,
          price = this.currentVariant?.price;

        const stickyPrice = $(
          "[data-sticky-add-to-cart] .money-subtotal .money"
        );
        const stickyComparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price .money"
        );

        if (window.subtotal.show) {
          let qty = quantityInput.val();

          subTotal = qty * price;
          subTotal = Shopify.formatMoney(subTotal, window.money_format);
          subTotal = extractContent(subTotal);

          const moneySpan = document.createElement("span");
          moneySpan.classList.add(
            window.currencyFormatted ? "money" : "money-subtotal"
          );
          moneySpan.innerText = subTotal;
          document.body.appendChild(moneySpan);

          if (this.checkNeedToConvertCurrency()) {
            let currencyCode = document
              .getElementById("currencies")
              ?.querySelector(".active")
              ?.getAttribute("data-currency");
            Currency.convertAll(
              window.shop_currency,
              currencyCode,
              "span.money",
              "money_format"
            );
          }

          subTotal = moneySpan.innerText;
          $(moneySpan).remove();

          if (window.subtotal.style == "1") {
            const pdView_subTotal =
              document.querySelector(".productView-subtotal .money") ||
              document.querySelector(".productView-subtotal .money-subtotal");
            if (pdView_subTotal != null) {
              pdView_subTotal.textContent = subTotal;
            }
          } else if (window.subtotal.style == "2") {
            text = window.subtotal.text.replace("[value]", subTotal);
          }
        } else {
          subTotal = Shopify.formatMoney(price, window.money_format);
          subTotal = extractContent(subTotal);
        }

        quantityInput.attr("data-price", this.currentVariant?.price);
        quantityInput.attr("disabled", true);
        addButton.setAttribute("disabled", true);
        addButton.textContent = text;
        quantityInput.closest("quantity-input").addClass("disabled");

        if (subTotal != 0 && stickyPrice.length) {
          stickyPrice.text(subTotal);
        }

        const thisStickyPrice = $("[data-sticky-add-to-cart] .sticky-price");
        const thisComparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price"
        );
        const compare_at_price = this.currentVariant?.compare_at_price;

        if (compare_at_price) {
          thisStickyPrice.addClass("has-compare-price");
          if (thisComparePrice.length) {
            thisComparePrice.attr("data-compare-price", compare_at_price);
          } else {
            thisStickyPrice.prepend(
              `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
            );
          }
        } else {
          thisStickyPrice.removeClass("has-compare-price");
          thisComparePrice.remove();
        }

        if (
          subTotal != 0 &&
          stickyComparePrice.length &&
          window.subtotal.show
        ) {
          let comparePrice = $(
              "[data-sticky-add-to-cart] .money-compare-price"
            ).data("compare-price"),
            qty = quantityInput.val();
          comparePrice = qty * comparePrice;
          comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
          comparePrice = extractContent(comparePrice);
          stickyComparePrice.text(comparePrice);
        }

        if (notifyMe.length > 0) {
          notifyMe
            .find(".halo-notify-product-variant")
            .val(this.currentVariant.title);
          notifyMe.find(".notifyMe-text").empty();
          notifyMe.slideDown("slow");
        }
      } else {
        var text,
          subTotal = 0,
          price = this.currentVariant?.price;

        const stickyPrice = $(
          "[data-sticky-add-to-cart] .money-subtotal .money"
        );

        if (window.subtotal.show) {
          let qty = quantityInput.val();

          subTotal = qty * price;
          subTotal = Shopify.formatMoney(subTotal, window.money_format);
          subTotal = extractContent(subTotal);

          const moneySpan = document.createElement("span");
          moneySpan.classList.add(
            window.currencyFormatted ? "money" : "money-subtotal"
          );
          moneySpan.innerText = subTotal;
          document.body.appendChild(moneySpan);

          if (this.checkNeedToConvertCurrency()) {
            let currencyCode = document
              .getElementById("currencies")
              ?.querySelector(".active")
              ?.getAttribute("data-currency");
            Currency.convertAll(
              window.shop_currency,
              currencyCode,
              "span.money",
              "money_format"
            );
          }

          subTotal = moneySpan.innerText;
          $(moneySpan).remove();

          if (window.subtotal.style == "1") {
            const pdView_subTotal =
              document.querySelector(".productView-subtotal .money") ||
              document.querySelector(".productView-subtotal .money-subtotal");
            if (pdView_subTotal != null) {
              pdView_subTotal.textContent = subTotal;
            }

            if (
              this.currentVariant.available &&
              maxValue <= 0 &&
              this.currentVariant.inventory_management == "shopify"
            ) {
              text = window.variantStrings.preOrder;
            } else {
              text = window.variantStrings.addToCart;
            }
          } else if (window.subtotal.style == "2") {
            text = window.subtotal.text.replace("[value]", subTotal);
          }
        } else {
          subTotal = Shopify.formatMoney(price, window.money_format);
          subTotal = extractContent(subTotal);
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == "shopify"
          ) {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }
        }

        quantityInput.attr("data-price", this.currentVariant?.price);
        quantityInput.attr("disabled", false);
        addButton.removeAttribute("disabled");
        addButton.textContent = text;
        quantityInput.closest("quantity-input").removeClass("disabled");

        if (subTotal != 0 && stickyPrice.length) {
          stickyPrice.text(subTotal);
        }

        const thisStickyPrice = $("[data-sticky-add-to-cart] .sticky-price");
        const thisComparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price"
        );
        const compare_at_price = this.currentVariant?.compare_at_price;

        if (compare_at_price) {
          thisStickyPrice.addClass("has-compare-price");
          if (thisComparePrice.length) {
            thisComparePrice.attr("data-compare-price", compare_at_price);
          } else {
            thisStickyPrice.prepend(
              `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
            );
          }
        } else {
          thisStickyPrice.removeClass("has-compare-price");
          thisComparePrice.remove();
        }

        const stickyComparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price .money"
        );
        if (
          subTotal != 0 &&
          stickyComparePrice.length &&
          window.subtotal.show
        ) {
          let comparePrice = $(
              "[data-sticky-add-to-cart] .money-compare-price"
            ).data("compare-price"),
            qty = quantityInput.val();
          comparePrice = qty * comparePrice;
          comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
          comparePrice = extractContent(comparePrice);
          stickyComparePrice.text(comparePrice);
        }

        if (notifyMe.length > 0) {
          notifyMe.slideUp("slow");
        }
      }
    }
  }

  updateStickyAddToCart(unavailable = true, disable = true) {
    if (this.item.find(".productView-stickyCart").length > 0) {
      const sticky = this.item.find(".productView-stickyCart");
      const itemImage = sticky.find(".sticky-image");
      const option = sticky.find(".select__select");
      const input = document
        .getElementById(`product-form-sticky-${this.dataset.product}`)
        ?.querySelector('input[name="id"]');
      const button = document
        .getElementById(`product-form-sticky-${this.dataset.product}`)
        ?.querySelector('[name="add"]');
      var quantityInput = this.item.find('input[name="quantity"]');
      var maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));

      if (unavailable) {
        var text = window.variantStrings.unavailable;

        button.setAttribute("disabled", true);
        button.textContent = text;
      } else {
        if (!this.currentVariant) return;

        const image = this.currentVariant?.featured_image;

        if (image != null) {
          itemImage.find("img").attr({
            src: image.src,
            srcset: image.src,
            alt: image.alt,
          });
        }

        option.val(this.currentVariant.id);

        if (disable) {
          var text = window.variantStrings.soldOut;

          button.setAttribute("disabled", true);
          button.textContent = text;
        } else {
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == "shopify"
          ) {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }

          button.removeAttribute("disabled");
          button.textContent = text;
        }

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  checkNeedToConvertCurrency() {
    var currencyItem = $(".dropdown-item[data-currency]");
    if (currencyItem.length) {
      return (
        (window.show_multiple_currencies &&
          Currency.currentCurrency != shopCurrency) ||
        window.show_auto_currency
      );
    } else {
      return;
    }
  }

  checkQuantityWhenVariantChange() {
    const parent = document.querySelector(".productView-details");
    var quantityInput = parent.querySelector("input.quantity__input");
    var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
    var inputValue = parseInt(quantityInput?.value);

    let value = inputValue;

    if (inputValue > maxValue && maxValue > 0) {
      value = maxValue;
    } else {
      value = inputValue;
    }

    if (value < 1 || isNaN(value)) value = 1;

    if (quantityInput) {
      quantityInput.value = value;
    }

    document.getElementById("product-add-to-cart").dataset.available =
      this.currentVariant.available && maxValue <= 0;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    const inputLength = inputWrappers.length;
    inputWrappers.forEach((option, index) => {
      option
        .querySelectorAll("[data-header-option]")
        .forEach(
          (selected) =>
            (selected.innerText = option.querySelector(":checked").value)
        );
      if (index === 0 && inputLength > 1) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputLength > 1
          ? inputWrappers[index - 1].querySelector(":checked").value
          : inputWrappers[index].querySelector(":checked").value;
      const optionInputsValue =
        inputLength > 1
          ? selectedOptionOneVariants
              .filter(
                (variant) =>
                  variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
          : this.variantData.map(
              (variantOption) => variantOption[`option${index + 1}`]
            );
      const availableOptionInputsValue =
        inputLength > 1
          ? selectedOptionOneVariants
              .filter(
                (variant) =>
                  variant.available &&
                  variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
          : this.variantData
              .filter((variant) => variant.available)
              .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(
        optionInputs,
        optionInputsValue,
        availableOptionInputsValue
      );
    });
  }

  setInputAvailability(
    optionInputs,
    optionInputsValue,
    availableOptionInputsValue
  ) {
    optionInputs.forEach((input) => {
      if (availableOptionInputsValue.includes(input.getAttribute("value"))) {
        input.classList.remove("soldout");
        input.innerText = input.getAttribute("value");
      } else {
        input.classList.add("soldout");
        optionInputsValue.includes(input.getAttribute("value"))
          ? (input.innerText = input.getAttribute("value") + " (Sold out)")
          : (input.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                input.getAttribute("value")
              ));
      }
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(
    optionInputs,
    optionInputsValue,
    availableOptionInputsValue
  ) {
    optionInputs.forEach((input) => {
      if (availableOptionInputsValue.includes(input.getAttribute("value"))) {
        input.nextElementSibling.classList.remove("soldout", "unavailable");
        input.nextElementSibling.classList.add("available");
      } else {
        input.nextElementSibling.classList.remove("available", "unavailable");
        input.nextElementSibling.classList.add("soldout");

        if (
          window.variantStrings.hide_variants_unavailable &&
          !optionInputsValue.includes(input.getAttribute("value"))
        ) {
          input.nextElementSibling.classList.add("unavailable");
          if (!input.checked) return;
          let inputsValue;
          availableOptionInputsValue.length > 0
            ? (inputsValue = availableOptionInputsValue)
            : (inputsValue = optionInputsValue);
          input
            .closest(".product-form__input")
            .querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
          this.dispatchEvent(new Event("change"));
        }
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class CombieVariants extends VariantRadios {
  constructor() {
    super();
  }

  async onVariantInit() {
    this.status = Object.create({});
    this.status.variantName = "Taille";
    this.status.customSize = "PERSONNALISÉE";
    this.status.plusSizes = [
      "EU50",
      "EU52",
      "EU54",
      "EU56",
      "EU58",
      "EU60",
      "PERSONNALISÉE",
    ];

    this.checkOptionsValidate();
    this.buyBefor();

    this.updateOptions();
    this.updateSizeChart();
    await this.updateMasterId();
    this.renderProductAjaxInfo();
    this.renderProductInfo();
    if (!this.currentVariant) {
      this.updateAttribute(true);
    } else {
      this.updateAttribute(false, !this.currentVariant.available);
    }
    this.updateVariantStatuses();
  }

  async onVariantChange(event) {
    if (!event.target.closest("fieldset")) return;
    this.preOptions = this.currentVariant?.options;
    this.updateOptions();
    let curIndex = this.options.findIndex((option) =>
      this.status.plusSizes.includes(option)
    );
    let index = this.currentVariant?.options
      ? this.currentVariant.options.findIndex((option) =>
          this.status.plusSizes.includes(option)
        )
      : "undefined";
    if (
      event.target.name !== this.status.variantName ||
      (index !== "undefined" &&
        !(
          !this.currentVariant.options ||
          (index > -1 && curIndex > -1) ||
          (index === -1 && curIndex === -1)
        ))
    ) {
      let variantImg = this.currentVariant?.featured_image;
      let variantMedia = document.querySelector("[data-variant-media]");
      if (variantMedia && variantImg) {
        variantMedia.firstElementChild.classList.add("loading");
        variantMedia
          .querySelector("[data-loading-spinner]")
          .classList.remove("hidden");
      }
    }
    this.updteMobileVariant();
    this.updateSizeChart();
    await this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (
      !this.options.includes(this.status.customSize) &&
      this.querySelector('input[value="PERSONNALISÉE"]')
    ) {
      this.emptyCustomOpts();
    }
    if (!this.options.includes(this.status.customSize)) {
      const sizeChart = document.querySelector("size-chart");
      if (sizeChart) sizeChart.updateSelected();
    }

    if (!this.currentVariant) {
      this.updateAttribute(true);
      this.updateStickyAddToCart(true);
    } else {
      this.updateVariantInput();
      this.updateMedia(event);
      this.updateURL();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateAttribute(false, !this.currentVariant.available);
      this.updateStickyAddToCart(false, !this.currentVariant.available);
      this.checkQuantityWhenVariantChange();
    }
  }

  setInputAvailability(
    optionInputs,
    optionInputsValue,
    availableOptionInputsValue
  ) {
    let unavailableOptionInputsValue = optionInputsValue.filter(
      (value) => availableOptionInputsValue.indexOf(value) == -1
    );
    optionInputs.forEach((input) => {
      if (unavailableOptionInputsValue.includes(input.getAttribute("value"))) {
        input.nextElementSibling.classList.remove("available", "unavailable");
        input.nextElementSibling.classList.add("soldout");

        if (
          window.variantStrings.hide_variants_unavailable &&
          !optionInputsValue.includes(input.getAttribute("value"))
        ) {
          input.nextElementSibling.classList.add("unavailable");
          if (!input.checked) return;
          let inputsValue;
          availableOptionInputsValue.length > 0
            ? (inputsValue = availableOptionInputsValue)
            : (inputsValue = optionInputsValue);
          input
            .closest(".product-form__input")
            .querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
          this.dispatchEvent(new Event("change"));
        }
      } else {
        input.nextElementSibling.classList.remove("soldout", "unavailable");
        input.nextElementSibling.classList.add("available");
      }
    });
  }

  updateMedia(event) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    if (event.target.name === this.status.variantName) {
      let curIndex = this.options.findIndex((option) =>
        this.status.plusSizes.includes(option)
      );
      let index = this.preOptions
        ? this.preOptions.findIndex((option) =>
            this.status.plusSizes.includes(option)
          )
        : "undefined";
      if (
        index !== "undefined" &&
        !((index > -1 && curIndex > -1) || (index === -1 && curIndex === -1))
      ) {
        this.updateStickyButtonMedia();
        this.updateMediaGallery();
      }
    } else {
      this.updateStickyButtonMedia();
      this.updateMediaGallery();
    }
  }

  updateStickyButtonMedia() {
    let variantMedia = document.querySelector(".sticky-info-container");
    if (variantMedia) {
      let image = this.currentVariant.featured_image
        ? this.currentVariant.featured_image
        : this.productImages[0];
      if (image) {
        let variantImage = variantMedia.querySelector("img");
        variantImage.setAttribute("src", image.src + "&width=180");
        variantImage.setAttribute("alt", image.alt);
      }
    }
  }

  async updateMediaGallery() {
    let handle;
    if (this.querySelector('input[name="Taille"]')) {
      handle = this.productData.find(
        (item) =>
          item.options.color == this.options[0] &&
          item.options.size.includes(this.options[1])
      ).handle;
    } else {
      handle = this.productData.find(
        (item) => item.options.color == this.options[0]
      ).handle;
    }
    let response = await fetch(`/products/${handle}?view=ajax_product_media`);
    let responseText = await response.text();
    let element = new DOMParser().parseFromString(responseText, "text/html");
    const source = document.querySelector("[data-image-gallery]");
    if (!source) return;
    source.replaceWith(element.querySelector("[data-image-gallery]"));
    window.galleryReinit($(".halo-productView"));
  }

  async updateMasterId() {
    this.decodeOptions();
    let result = await this.getVariantData();
    if (result) {
      this.currentVariant = result.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    } else {
      this.currentVariant = null;
    }
  }

  async getVariantData() {
    this.productData =
      this.productData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    let handle;
    if (this.querySelector('input[name="Taille"]')) {
      handle = this.productData.find(
        (item) =>
          item.options.color == this.options[0] &&
          item.options.size.includes(this.options[1])
      ).handle;
    } else {
      handle = this.productData.find(
        (item) => item.options.color == this.options[0]
      ).handle;
    }
    this.setAttribute("data-url", `/products/${handle}`);
    let data = await this.getProductJson(handle);
    this.productImages = data.images;
    if (data) {
      this.variantData = data.variants;
    } else {
      this.variantData = null;
    }
    return this.variantData;
  }

  async getProductJson(handle) {
    try {
      let response = await fetch(`/products/${handle}.js`);
      let result = await response.json();
      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }
}
customElements.define("combie-variants", CombieVariants);

class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.unit = "cm";
    this.unitToggleButton = this.querySelector(".unit-switch");
    this.inchTable = this.querySelector('table[unit="inch"]');
    this.cmTable = this.querySelector('table[unit="cm"]');
    this.unitToggleButton.addEventListener("click", this.unitChange.bind(this));

    this.updateSelected();
  }

  unitChange() {
    this.changeStatus();
    const customOption = document.querySelectorAll("custom-option");
    customOption.forEach((option) => option.changeStatus());
  }

  changeStatus() {
    this.unit = this.unit === "inch" ? "cm" : "inch";
    this.unitToggleButton.classList.toggle("right");
    if (this.unit === "inch") {
      this.inchTable.style.display = "table";
      this.cmTable.style.display = "none";
    } else {
      this.inchTable.style.display = "none";
      this.cmTable.style.display = "table";
    }
  }

  updateSelected() {
    const inchSizeCells = Array.from(
      this.inchTable.querySelectorAll("tbody tr")
    );
    const cmSizeCells = Array.from(this.cmTable.querySelectorAll("tbody tr"));
    const combieVariant =
      document.querySelector("variant-selects") || document.querySelector("variant-radios") || document.querySelector("combie-variants");
    if (!combieVariant) return;
    const selectedOptions = combieVariant.options;
    let inchIdx = inchSizeCells.findIndex((cell) =>
      selectedOptions.includes(cell.getAttribute("size"))
    );
    let cmIdx = cmSizeCells.findIndex((cell) =>
      selectedOptions.includes(cell.getAttribute("size"))
    );
    inchSizeCells.map((cell) => {
      cell.style.display = "none";
      cell.classList.remove("selected");
    });
    cmSizeCells.map((cell) => {
      cell.style.display = "none";
      cell.classList.remove("selected");
    });
    if (inchIdx <= 0) {
      inchSizeCells[0].style.display = "table-row";
      inchSizeCells[1].style.display = "table-row";
      inchSizeCells[2].style.display = "table-row";
      inchSizeCells[0].classList.add("selected");
    } else if (inchIdx >= inchSizeCells.length - 1) {
      const len = inchSizeCells.length;
      inchSizeCells[len - 1].style.display = "table-row";
      inchSizeCells[len - 2].style.display = "table-row";
      inchSizeCells[len - 3].style.display = "table-row";
      inchSizeCells[len - 1].classList.add("selected");
    } else {
      inchSizeCells[inchIdx].style.display = "table-row";
      inchSizeCells[inchIdx - 1].style.display = "table-row";
      inchSizeCells[inchIdx + 1].style.display = "table-row";
      inchSizeCells[inchIdx].classList.add("selected");
    }
    if (cmIdx <= 0) {
      cmSizeCells[0].style.display = "table-row";
      cmSizeCells[1].style.display = "table-row";
      cmSizeCells[2].style.display = "table-row";
      cmSizeCells[0].classList.add("selected");
    } else if (cmIdx >= cmSizeCells.length - 1) {
      const len = cmSizeCells.length;
      cmSizeCells[len - 1].style.display = "table-row";
      cmSizeCells[len - 2].style.display = "table-row";
      cmSizeCells[len - 3].style.display = "table-row";
      cmSizeCells[len - 1].classList.add("selected");
    } else {
      cmSizeCells[cmIdx].style.display = "table-row";
      cmSizeCells[cmIdx - 1].style.display = "table-row";
      cmSizeCells[cmIdx + 1].style.display = "table-row";
      cmSizeCells[cmIdx].classList.add("selected");
    }
  }
}

customElements.define("size-chart", SizeChart);

class CustomOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.unit = "cm";
    this.optionValues = Object.create({});
    this.agreePolicy = false;
    this.descBox = this.querySelector("[data-customize-option-desc]");
    this.msgBox = this.querySelector("[data-error-message]");
    this.unitToggleButton = this.querySelector(".unit-switch");
    this.optionDesc = this.querySelector("[data-customize-option-desc]");
    this.optionUl = this.querySelector("ul.dress_ul");
    this.optionPolicy = this.querySelector(".return_support_notice");
    this.inputOptions = Array.from(this.optionUl.querySelectorAll("input"));
    this.selectOptions = Array.from(this.optionUl.querySelectorAll("select"));

    this.init();

    // Unit toggle button event handler
    this.unitToggleButton.addEventListener("click", this.unitChange.bind(this));
    // Option focus event handler
    this.inputOptions.forEach((input) => {
      input.addEventListener("focus", this.showOptionDesc.bind(this));
    });
    this.selectOptions.forEach((select) => {
      select.addEventListener("focus", this.showOptionDesc.bind(this));
    });
    this.inputOptions.forEach((input) => {
      input.addEventListener("blur", this.valueCheck.bind(this));
    });
    // Option policy checkbox change envet handler
    this.optionPolicy.addEventListener("change", this.policyChange.bind(this));
  }

  init() {
    const options = this.optionUl.querySelectorAll("input, select");
    options.forEach((o) => (this.optionValues[o.dataset.option] = o.value));
  }

  disconnectedCallback() {
    document.body.classList.remove("custom-option-show");
  }

  unitChange() {
    this.changeStatus();
    const sizeChart = document.getElementById("size_detail_show");
    if (sizeChart) sizeChart.changeStatus();
  }

  changeStatus() {
    const options = this.optionUl.querySelectorAll("input, select"); // All custom size options
    const items = this.optionUl.querySelectorAll("span.unit_item"); // Custom option details

    // Change unit value
    this.unit = this.unit === "inch" ? "cm" : "inch";

    // Change toggle button status, option units, option placeholder, option input value, size chart unit
    this.unitToggleButton.classList.toggle("right");
    items.forEach(
      (item) =>
        (item.firstChild.nodeValue = `(${this.unit === "inch" ? "in" : "cm"})`)
    );
    options.forEach((option) => {
      // Change option placeholder
      if (option.nodeName === "INPUT") {
        let placeholderStr = option.getAttribute("placeholder");
        let [min, max] = placeholderStr.split(" - ");
        option.setAttribute(
          "placeholder",
          `${this.unitConvertor(min)} - ${this.unitConvertor(max)}`
        );
        option.value = parseFloat(this.unitConvertor(option.value));
        this.optionValues[option.dataset.option] = parseFloat(
          this.unitConvertor(option.value)
        );
      }
    });
  }

  valueCheck(event) {
    let placeholder = event.target.getAttribute("placeholder");
    if (!placeholder) return;
    let [min, max] = placeholder.split(" - ");
    const noticeBox = event.target.closest("li").querySelector("p.notice");
    if (!noticeBox) return;
    if (event.target.value < parseFloat(min)) {
      noticeBox.textContent = `La mesure minimale de la ${
        event.target.dataset.option
      } pour tous les styles ${this.dataset.member} est de ${
        this.unit === "inch" ? min + " inches" : min + " cm"
      }.`;
    }
    if (event.target.value > parseFloat(max)) {
      noticeBox.textContent = `La mesure de ${
        event.target.dataset.option
      } maximale pour tous les styles ${this.dataset.member} est de ${
        this.unit === "inch" ? max + " inches" : max + " cm"
      }.`;
    }
    this.optionValues[`${event.target.dataset.option}`] = event.target.value;
    let result = this.checkValidate();
    if (result) {
      const addToCartBtns = document.querySelectorAll(
        "[data-btn-addtocart], [data-dynamic-checkout-wrapper]"
      );
      addToCartBtns.forEach((button) => button.removeAttribute("disabled"));
    }
  }

  showOptionDesc(event) {
    const addToCartBtns = document.querySelectorAll(
      "[data-btn-addtocart], [data-dynamic-checkout-wrapper]"
    );
    addToCartBtns.forEach((button) => button.removeAttribute("disabled"));
    if (event.target.nodeName !== "INPUT" && event.target.nodeName !== "SELECT")
      return;
    this.descBox.innerHTML = `<span>${
      event.target.closest("li").querySelector("span.name")?.innerHTML
    }</span> ${event.target.closest("label").dataset.description}`;
    if (event.target.nodeName !== "INPUT") return;
    const noticeBox = event.target.closest("li").querySelector("p.notice");
    if (noticeBox) noticeBox.textContent = "";
  }

  policyChange(event) {
    this.agreePolicy = event.target.checked;
    let result = this.checkValidate();
    if (result) {
      const addToCartBtns = document.querySelectorAll(
        "[data-btn-addtocart], [data-dynamic-checkout-wrapper]"
      );
      addToCartBtns.forEach((button) => button.removeAttribute("disabled"));
    }
  }

  unitConvertor(num) {
    return this.unit === "inch"
      ? (parseFloat(num) * 0.3937).toFixed(2)
      : (parseFloat(num) * 2.54).toFixed(2);
  }

  checkValidate() {
    this.showErrorMessage("");
    const options = Array.from(this.optionUl.querySelectorAll("input"));
    let properties = [];
    for (let option of options) {
      let placeholder = option.getAttribute("placeholder");
      let [min, max] = placeholder.split(" - ");
      if (option.value < parseFloat(min) || parseFloat(max) < option.value) {
        properties.push(option.dataset.option);
      }
    }
    if (properties.length > 0 || !this.agreePolicy) {
      if (properties.length > 0 && !this.agreePolicy) {
        this.showErrorMessage(
          `Votre valeur de taille personnalisée : ${properties.join(
            ", "
          )} est invalide, veuillez d'abord accepter notre politique de retour et d'échange.`
        );
      } else if (properties.length > 0) {
        this.showErrorMessage(
          `Votre valeur de taille personnalisée : ${properties.join(", ")} est invalide.`
        );
      } else {
        this.showErrorMessage(
          `Veuillez d’abord accepter notre politique de retour et d’échange.`
        );
      }
      return false;
    }
    return true;
  }

  showErrorMessage(msg) {
    this.msgBox.innerHTML = msg;
  }

  showSelectedValues() {
      const customOptionBox = document.querySelector('[data-custom-size-values]');
      if (!customOptionBox) return;
      this.init();
      const unitElem = customOptionBox.querySelector('[data-option="Unit"]');
      if (unitElem) unitElem.textContent = this.unit;
      for (let [key, value] of Object.entries(this.optionValues)) {
          const numElem = customOptionBox.querySelector(`[data-option="${key}"]`);
          if (!numElem) continue;
          numElem.textContent = value;
      }
      customOptionBox.style.display = 'block';
  }
}

customElements.define("custom-option", CustomOption);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    if (!this.checkHasMultipleVariants()) {
      this.initProductQuantity();
      this.checkVariantInventory();
    }
  }

  onInputChange(event) {
    event.preventDefault();
    var inputValue = this.input.value;
    var maxValue = parseInt(this.input.dataset.inventoryQuantity);
    var currentId = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="id"]')?.value;
    var saleOutStock =
      document.getElementById("product-add-to-cart").dataset.available ===
        "true" || false;
    const addButton = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="add"]');

    if (inputValue < 1) {
      inputValue = 1;

      this.input.value = inputValue;
    }

    if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
      var arrayInVarName = `selling_array_${this.input.dataset.product}`,
        itemInArray = window[arrayInVarName],
        itemStatus = itemInArray[currentId];

      if (itemStatus == "deny") {
        inputValue = maxValue;
        this.input.value = inputValue;
        const message = getInputMessage(maxValue);
        showWarning(message, 3000);
      }
    } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
      this.input.value = inputValue;
    }

    if (window.subtotal.show) {
      var text,
        price = this.input.dataset.price,
        subTotal = 0;

      var parser = new DOMParser();

      subTotal = inputValue * price;
      subTotal = Shopify.formatMoney(subTotal, window.money_format);
      subTotal = extractContent(subTotal);

      const moneySpan = document.createElement("span");
      moneySpan.classList.add(
        window.currencyFormatted ? "money" : "money-subtotal"
      );
      moneySpan.innerText = subTotal;
      document.body.appendChild(moneySpan);

      if (this.checkNeedToConvertCurrency()) {
        let currencyCode = document
          .getElementById("currencies")
          ?.querySelector(".active")
          ?.getAttribute("data-currency");
        Currency.convertAll(
          window.shop_currency,
          currencyCode,
          "span.money",
          "money_format"
        );
      }

      subTotal = moneySpan.innerText;
      $(moneySpan).remove();

      if (window.subtotal.style == "1") {
        const pdView_subTotal =
          document.querySelector(".productView-subtotal .money") ||
          document.querySelector(".productView-subtotal .money-subtotal");

        pdView_subTotal.textContent = subTotal;
      } else if (window.subtotal.style == "2") {
        text = window.subtotal.text.replace("[value]", subTotal);

        addButton.textContent = text;
      }

      const stickyPrice = $("[data-sticky-add-to-cart] .money-subtotal .money");
      const stickyComparePrice = $(
        "[data-sticky-add-to-cart] .money-compare-price .money"
      );

      if (stickyPrice.length) {
        stickyPrice.text(subTotal);
      }

      if (stickyComparePrice.length && window.subtotal.show) {
        let comparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price"
        ).data("compare-price");
        comparePrice = inputValue * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyComparePrice.text(comparePrice);
      }
    }

    if (
      this.classList.contains("quantity__group--2") ||
      this.classList.contains("quantity__group--3")
    ) {
      const mainQty = document.querySelector(
        ".quantity__group--1 .quantity__input"
      );
      mainQty.value = inputValue;

      const mainQty2Exists = !!document.querySelector(
        ".quantity__group--2 .quantity__input"
      );
      const mainQty3Exists = !!document.querySelector(
        ".quantity__group--3 .quantity__input"
      );

      if (this.classList.contains("quantity__group--2") && mainQty3Exists) {
        const mainQty3 = document.querySelector(
          ".quantity__group--3 .quantity__input"
        );
        mainQty3.value = inputValue;
      } else if (
        this.classList.contains("quantity__group--3") &&
        mainQty2Exists
      ) {
        const mainQty2 = document.querySelector(
          ".quantity__group--2 .quantity__input"
        );
        mainQty2.value = inputValue;
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  checkHasMultipleVariants() {
    const arrayInVarName = `product_inven_array_${
      this.querySelector("[data-product]").dataset.product
    }`;
    this.inven_array = window[arrayInVarName];
    return Object.keys(this.inven_array).length > 1;
  }

  initProductQuantity() {
    if (this.inven_array != undefined) {
      var inven_num = Object.values(this.inven_array),
        inventoryQuantity = parseInt(inven_num);

      this.querySelector('input[name="quantity"]').setAttribute(
        "data-inventory-quantity",
        inventoryQuantity
      );
      this.querySelector('input[name="quantity"]').dataset.inventoryQuantity =
        inventoryQuantity;
    }
  }

  checkVariantInventory() {
    const addBtn = document.getElementById("product-add-to-cart");
    this.input.disabled = addBtn.disabled;
    this.querySelector(".btn-quantity.minus").disabled = addBtn.disabled;
    this.querySelector(".btn-quantity.plus").disabled = addBtn.disabled;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        document.querySelector('.product-option [type="application/json"]')
          .textContent
      );
    return this.variantData;
  }
}

customElements.define("quantity-input", QuantityInput);

function hotStock(inventoryQuantity) {
  const productView = document.querySelector(".productView");
  const hotStock = productView.querySelector(".productView-hotStock");
  if (hotStock) {
    let hotStockText = hotStock.querySelector(".hotStock-text"),
      maxStock = parseFloat(hotStock.dataset.hotStock),
      textStock;

    if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
      hotStock.matches(".style-2")
        ? (textStock = window.inventory_text.hotStock2.replace(
            "[inventory]",
            inventoryQuantity
          ))
        : (textStock = window.inventory_text.hotStock.replace(
            "[inventory]",
            inventoryQuantity
          ));
      if (hotStockText) hotStockText.innerHTML = textStock;
      hotStock.classList.remove("is-hide");
    } else {
      hotStock.classList.add("is-hide");
    }

    if (hotStock.matches(".style-2")) {
      const invenProgress = (inventoryQuantity / maxStock) * 100,
        hotStockProgressItem = hotStock.querySelector(
          ".hotStock-progress-item"
        );
      if (hotStockProgressItem)
        hotStockProgressItem.style.width = `${invenProgress}%`;
    }
  }
}
const hotStockNoOptions = document.querySelector(
  ".productView .productView-hotStock[data-current-inventory]"
);
if (hotStockNoOptions) {
  const inventoryQuantity = parseFloat(
    hotStockNoOptions.dataset.currentInventory
  );
  hotStock(inventoryQuantity);
}

function showWarning(content, time = null) {
  if (window.warningTimeout) {
    clearTimeout(window.warningTimeout);
  }
  const warningPopupContent = document
    .getElementById("halo-warning-popup")
    .querySelector("[data-halo-warning-content]");
  warningPopupContent.textContent = content;
  document.body.classList.add("has-warning");

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove("has-warning");
    }, time);
  }
}

function getInputMessage(maxValue) {
  var message = window.cartStrings.addProductOutQuantity.replace(
    "[maxQuantity]",
    maxValue
  );
  return message;
}
